/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'
import { createStyles, makeStyles } from '@mui/styles'

import { Logger, LoggerTypes } from '../../../../../../utils'
import {
  Button,
  buttonModes,
  buttonTypes,
  FormTitle,
  Icon,
  iconNames,
  AccessControl
} from '../../../../../../components'
import { attributesNames, interactionModes, userRightTypes } from '../../../../../../constants'
import { FlowElementTaskInteractionDialog } from '../FlowElementTaskInteractionDialog'
import { FlowElementTaskInteractionVariableStartCard } from '../FlowElementTaskInteractionVariableStartCard'
import { FlowElementTaskInteractionVariableFinishCard } from '../FlowElementTaskInteractionVariableFinishCard'
import '../../../common-elements-style.scss'
import './style.scss'

const useStyles = makeStyles((theme) =>
  createStyles({
    headerColor: {
      color: theme.palette.secondary.main,
      opacity: '0.6'
    }
  })
)

export const FlowElementTaskInteractionVariablesPanel = ({
  currentProject,
  currentScenario,
  currentFlowGroup,
  currentTaskInstance,
  variables
  // refreshAfterSaving
}) => {
  const { t } = useTranslation()
  const styleClasses = useStyles()

  const variableInteractions =
    (currentTaskInstance?.variable_interactions &&
      currentTaskInstance.variable_interactions.length > 0 &&
      currentTaskInstance.variable_interactions) ||
    null

  // -- sort the array of object to prevents from changing the display order.
  // -- the backend doesn't always returns the data in the same order.
  if (variableInteractions) {
    variableInteractions.sort((a, b) => (a.variable.name > b.variable.name ? 1 : -1))
  }

  const [openDialog, setOpenDialog] = useState(false)
  const [mode, setMode] = useState(interactionModes.START)
  // const [variableInteractions, setVariableInteractions] = useState(_variableInteractions)

  // useEffect(() => {
  //   Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskInteractionVariablesPanel.useEffect()', {
  //     currentTaskInstance,
  //     variableInteractions
  //   })

  //   setVariableInteractions(_variableInteractions)
  // }, [currentTaskInstance])

  const onClickAddInteractionStart = (e) => {
    e.stopPropagation()

    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskInteractionVariablesPanel.onClickAddInteractionStart()', {
      openDialog
    })

    setMode(interactionModes.START)
    setOpenDialog(!openDialog)
  }

  const onClickAddInteractionEnd = (e) => {
    e.stopPropagation()

    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskInteractionVariablesPanel.onClickAddInteractionEnd()', {
      openDialog
    })

    setMode(interactionModes.FINISH)
    setOpenDialog(!openDialog)
  }

  // --

  Logger.trace(LoggerTypes.CONTAINER, 'FlowElementTaskInteractionVariablesPanel.render()', {
    currentTaskInstance,
    variableInteractions
  })

  return (
    <div className="FlowElementTaskInteractionVariablesPanel">
      <div>
        <form>
          {/* == ON START == */}
          <FormTitle
            className={`parameterGroup ${styleClasses.headerColor}`}
            title={t('flowActions.tasks.panels.interactions.variables.on_start.title')}
            icon={iconNames.FLAG_START}
            iconSize={16}
          />
          <Grid container spacing={2} style={{ padding: '10px' }}>
            {/*  Buttons [VARIABLE]  */}
            <Grid item xs={12} sm={12} style={{ position: 'relative' }}>
              <div className="btCont">
                <AccessControl userPermissions={[userRightTypes.SCENARIO_ATTRIBUTES_EDIT]} renderNoAccess={() => <></>}>
                  <Button
                    mode={buttonModes.HEADER}
                    type={buttonTypes.BUTTON}
                    tooltip={t('flowActions.tasks.panels.interactions.variables.on_start.button_action.tooltip')}
                    onClick={onClickAddInteractionStart}
                    icon={<Icon name={iconNames.PLUS} size={14} />}
                  />
                </AccessControl>
              </div>
              <div>
                {
                  // -- variables START
                  (variableInteractions &&
                    variableInteractions
                      .filter((el) => el.type === interactionModes.START)
                      .map(
                        (currentInteraction, index) =>
                          currentInteraction && (
                            <FlowElementTaskInteractionVariableStartCard
                              key={`variable-interactions-start-${index}-${currentInteraction?.id}`}
                              currentProject={currentProject}
                              currentScenario={currentScenario}
                              currentFlowGroup={currentFlowGroup}
                              currentTaskInstance={currentTaskInstance}
                              currentInteraction={currentInteraction}
                              // refreshAfterSaving={refreshAfterSaving}
                            />
                          )
                      )) || <i className="notFound">{t('flowActions.tasks.panels.interactions.variables.not_found')}</i>
                }
              </div>
            </Grid>
          </Grid>

          {/* == ON FINISH == */}
          <FormTitle
            className={`parameterGroup ${styleClasses.headerColor}`}
            title={t('flowActions.tasks.panels.interactions.variables.on_finish.title')}
            icon={iconNames.FLAG_END}
            iconSize={16}
          />
          <Grid container spacing={2} style={{ padding: '10px' }}>
            {/*  Buttons [VARIABLE]  [RESOURCE]  */}
            <Grid item xs={12} sm={12} style={{ position: 'relative' }}>
              <div className="btCont">
                <AccessControl userPermissions={[userRightTypes.SCENARIO_ATTRIBUTES_EDIT]} renderNoAccess={() => <></>}>
                  <Button
                    mode={buttonModes.HEADER}
                    type={buttonTypes.BUTTON}
                    tooltip={t('flowActions.tasks.panels.interactions.variables.on_finish.button_action.tooltip')}
                    onClick={onClickAddInteractionEnd}
                    icon={<Icon name={iconNames.PLUS} size={14} />}
                  />
                </AccessControl>
              </div>
              <div>
                {
                  // -- variables END
                  (variableInteractions &&
                    variableInteractions
                      .filter((el) => el.type === interactionModes.FINISH)
                      .map(
                        (currentInteraction, index) =>
                          currentInteraction && (
                            <FlowElementTaskInteractionVariableFinishCard
                              key={`variable-interactions-finish-${index}-${currentInteraction?.id}`}
                              currentProject={currentProject}
                              currentScenario={currentScenario}
                              currentFlowGroup={currentFlowGroup}
                              currentTaskInstance={currentTaskInstance}
                              currentInteraction={currentInteraction}
                              // refreshAfterSaving={refreshAfterSaving}
                            />
                          )
                      )) || <i className="notFound">{t('flowActions.tasks.panels.interactions.variables.not_found')}</i>
                }
              </div>
            </Grid>
          </Grid>
        </form>
        {openDialog && (
          <FlowElementTaskInteractionDialog
            currentProject={currentProject}
            currentScenario={currentScenario}
            currentFlowGroup={currentFlowGroup}
            currentTaskInstance={currentTaskInstance}
            variables={variables}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            mode={mode}
            type={attributesNames.VARIABLES}
            // refreshAfterSaving={refreshAfterSaving}
          />
        )}
      </div>
    </div>
  )
}

FlowElementTaskInteractionVariablesPanel.displayName = 'FlowElementTaskInteractionVariablesPanel'

FlowElementTaskInteractionVariablesPanel.propTypes = {
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object.isRequired,
  currentFlowGroup: PropTypes.object.isRequired,
  currentTaskInstance: PropTypes.object,
  variables: PropTypes.arrayOf(PropTypes.object)
  // -- refresh after saving
  // refreshAfterSaving: PropTypes.func
}

FlowElementTaskInteractionVariablesPanel.defaultProps = {
  currentProject: null,
  currentScenario: null,
  currentFlowGroup: null,
  currentTaskInstance: null,
  variables: []
  // refreshAfterSaving: () => {}
}
